import {
    Component,
    ElementRef,
    ViewEncapsulation,
    inject,
    input,
    ChangeDetectionStrategy,
    computed,
    OnInit,
} from '@angular/core';

const sharedStylesheet = new CSSStyleSheet();
sharedStylesheet.replaceSync(`:host { --gap: initial; display: flex; gap: var(--gap); }`);

@Component({
    selector: 'bazis-stars',
    templateUrl: './stars.component.html',
    // styleUrls: ['stars.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class StarsElement implements OnInit {
    public el = inject(ElementRef);

    readonly ratingValue = input<number>(0);

    readonly onlyFloat = computed(() => {
        return this.ratingValue() - Math.trunc(this.ratingValue());
    });

    readonly firstFloatNumber = computed(() => {
        return Number(this.onlyFloat?.toString().slice(2, 3)) || 0;
    });

    ngOnInit(): void {
        const host = this.el.nativeElement;
        if (host && host.shadowRoot) {
            const shadowRoot = host.shadowRoot;
            const styles = shadowRoot.querySelectorAll('style');
            styles.forEach((style) => style.remove());
            shadowRoot.adoptedStyleSheets = [sharedStylesheet];
        }
    }

    hasHalf(npp) {
        return npp === Math.trunc(this.ratingValue()) + 1 && this.firstFloatNumber() > 4;
    }

    hasActive(npp) {
        const ratingValue = this.ratingValue();
        return (
            (npp === Math.trunc(ratingValue) + 1 && this.firstFloatNumber() > 4) ||
            npp <= ratingValue
        );
    }
}
